import React, { useState, useEffect, useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import cl from './Navigation.module.css';
import Logo from "../Logo/Logo";
import Users from "../../../assets/Icon/Users";
import User from "../../../assets/Icon/User";
import Folder from "../../../assets/Icon/Folder";
import Home from "../../../assets/Icon/Home";
import Download from "../../../assets/Icon/Download";
import Dashboard from "../../../assets/Icon/Dashboard";
import Logs from "../../../assets/Icon/Logs";
import Calculator from "../../../assets/Icon/Calculator";
import Ship from "../../../assets/Icon/Ship";
import ContainerIcon from "../../../assets/Icon/Container";
import Wallet from "../../../assets/Icon/Wallet";
import Car from "../../../assets/Icon/Car";
import Sms from "../../../assets/Icon/SmsIcon";
import Settings from "../../../assets/Icon/Settings";
import Arrow from "../../../assets/Icon/Arrow";
import Logout from "../../../assets/Icon/Logout";
import Task from "../../../assets/Icon/Task";
import { useAuth } from '../../../providers/authProvider';
import CurrentUserModal from '../../Entity/Users/CurrentUserModal/Add';
import { AppContext } from '../../../providers/appProvider';

import ContainerLogo from '../../../assets/Logo/ContainerLogo';
import RoleLanguage from '../RoleLanguage/RoleLanguage';
import AIG from '../../../assets/Logo/AIG';
import Automoby from '../../../assets/Logo/Automoby';
import Autonomo from '../../../assets/Logo/Autonomo';
import { baseFileURL } from '../../../Api';
import OkModal from '../OkModal/OkModal';
import ErrorModal from '../ErrorModal/ErrorModal';
import { useContainer } from '../../../hooks/useContainer';
import Quotation from '../../../assets/Icon/Quotation';
import Booking from '../../../assets/Icon/Booking';
import Flag from '../../UI/Flag/Flag'; 

import { useTranslation } from 'react-i18next';

const Navigation = () => {
  const { t, i18n } = useTranslation();
  const { appState, app } = useContext(AppContext);
  const auth = useAuth();
  const { containerService } = useContainer(-1, false);

  const logout = () => {
    auth.logout();
  };
  const [isModalUserOpen, setIsModalUserOpen] = useState(false);

  const linkData = [
    { status_id: 1, text: "ახალი", color: "#ffb142", count: 0, url: "/containers?status_id=1" },
    { status_id: 3, text: "შემოსული", color: "#6900c6", count: 0, url: "/containers?status_id=3" }, 
    { status_id: 2, text: "გახსნილია", color: "#00bcd4", count: 0, url: "/containers?status_id=2" }, 
    { status_id: 4, text: "არქივი", color: "#009688", count: 0, url: "/containers?status_id=4&is_archive=true" },
    { is_transit: 1, text: "ტრანზიტი", color: "#166DE7", count: 0, url: "/containers?all=true&limit=50&order_by=id&page=1&search=&status_id=0&is_transit=1&green=0&bl_search=0&price_filter=0&custom_filter=0&created_at_min=&created_at_max=&entry_at_min=&entry_at_max=&open_at_min=&open_at_max=&taken_at_min=&taken_at_max=&shipper_id=0&marine_line_id=0&is_deleted=false&is_archive=false" }
  ];
  
  const [combinedLinkData, setCombinedLinkData] = useState(linkData);

  const location = useLocation();
  let linkDefaultDbPath;

  if (app.hasPermission("TRANSPORT_PRICE_PAGE_SHOW")) {
    linkDefaultDbPath = "/databases/roles";
  } else if (app.hasPermission("SITES_PAGE_SHOW")) {
    linkDefaultDbPath = "/databases/websites";
  } else if (app.hasPermission("AGENTS_PAGE_SHOW")) {
    linkDefaultDbPath = "/databases/agents";
  }  else if (app.hasPermission("PERMISSION_PAGE_SHOW")) {
    linkDefaultDbPath = "/databases/permissions";
  } else if (app.hasPermission("ROLE_PAGE_SHOW")) {
    linkDefaultDbPath = "/databases/roles";
  }

  const sortedRoles = [...appState.roles].sort((a, b) => {
    if (a.description < b.description) {
      return -1;
    }
    if (a.description > b.description) {
      return 1;
    }
    return 0;
  });
  const canShowUsers = app.hasPermission("USER_PAGE_SHOW");
  const canRegisterOwnDealer = app.hasPermission("USER_DEALER_REGISTER_OWN") && !canShowUsers;
  const dealerRole = appState.roles.find(role => role.name === "dealer");
  const usersLink = canRegisterOwnDealer ? `/users/${dealerRole?.id || 0}` : "/users/0";
  const visibleUserRoles = canRegisterOwnDealer ? [dealerRole].filter(Boolean) : sortedRoles;

  const handleLinkClick = () => {
    if (window.location.pathname === '/finances') {
      window.location.href = '/finances';
    }
  };

  const handleLinkClickContainer = () => {
    if (window.location.pathname === '/containers') {
      window.location.href = '/containers';
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (location.pathname.includes("containers")) {
        try {
          const response = await containerService.countStatuses();
  
          const updatedLinkData = linkData.map(link => {

            if (link.status_id) {
              const matchingData = response.statuses.find(item => item.status_id === link.status_id);
              return {
                ...link,
                count: matchingData ? matchingData.count : link.count
              };
            } 

            if (link.is_transit === 1) {
              return {
                ...link,
                count: response.Transits
              };
            }
  
            return link;
          });
  
          setCombinedLinkData(updatedLinkData);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };
  
    fetchData();
  }, [location]);
  console.log("has permission: ", app.hasPermission("QUOTATION_PAGE_SHOW"))

  return (
    <>
      {appState.ok && <OkModal message={appState.ok} onClose={() => app.clearOk(false)} />}
      {appState.error && <ErrorModal message={appState.error} onClose={() => app.clearError(false)} />}
      <div className={cl.headerMobile}>
        <div className={
          baseFileURL === "https://finance.automoby.ge"
            ? cl.logoMobile + ' ' + cl.automoby
            : baseFileURL === "https://crm.aig.com.ge" ||baseFileURL === "https://crmdev.aig.com.ge"
              ? cl.logoMobile + ' ' + cl.AIG
              : baseFileURL === "https://i-logistics.net" || baseFileURL === "https://dev.i-logistics.net"
                ? cl.containers
                : cl.logoMobile
        }>
          { 
            baseFileURL === "https://finance.automoby.ge" ? app.hasPermission("FINANCE_VIEW") &&
              
              <Link to="/finances" onClick={handleLinkClick} className={location.pathname.startsWith('/finances') ? cl.active : ''}>
                <Automoby />
              </Link>

            : baseFileURL === "https://crm.autonomo.kz" ? app.hasPermission("FINANCE_VIEW") &&
            
              <Link to="/finances" onClick={handleLinkClick} className={location.pathname.startsWith('/finances') ? cl.active : ''}>
                <Autonomo/>
              </Link>

            : baseFileURL === "https://crm.aig.com.ge" ||baseFileURL === "https://crmdev.aig.com.ge" ? app.hasPermission("FINANCE_VIEW") &&
              <Link to="/finances" onClick={handleLinkClick} className={location.pathname.startsWith('/finances') ? cl.active : ''}>
                <AIG />
              </Link>
            
            : baseFileURL === "https://i-logistics.net" || baseFileURL === "https://dev.i-logistics.net"
                ? app.hasPermission("CONTAINER_PAGE_SHOW") &&
                <Link to="/containers" onClick={handleLinkClickContainer} className={location.pathname.startsWith('/finances') ? cl.active : ''}>
                  <div className={cl.LogoContainer}>
                    <ContainerLogo />
                    <span>i-Logistics</span>
                  </div>
                </Link>
                : ""
          }
        </div>
        <div className={cl.barBTN} onClick={() => {
          const nav = document.querySelector('.' + cl.navigation);
          const barBTN = document.querySelector('.' + cl.barBTN);
          const overlayBG = document.querySelector('.' + cl.overlayBG);
          nav.classList.toggle(cl.active);
          barBTN.classList.toggle(cl.active);
          overlayBG.classList.toggle(cl.active);
        }}>
          <span className={cl.bar1 + ' ' + cl.bar}></span>
          <span className={cl.bar2 + ' ' + cl.bar}></span>
        </div>
      </div>
      <div className={cl.navigation}>
        <div className={cl.navSmall}>
          <Logo auth={auth} />
          <div className={cl.mainNavButton} style={{ marginBottom: "10px" }}>
            <Link onClick={() => setIsModalUserOpen(true)} className={location.pathname.startsWith('/profile') ? cl.active : ''}>
              <span className={cl.textmenu} >
                {appState.user ? (
                  <>
                    <div className={cl.userName} style={{ fontWeight: "700", lineHeight: "1.2" }}>{appState.user.firstname} {appState.user.lastname}</div>
                    <div className={cl.userRole} style={{ fontWeight: "500", lineHeight: "1.2", fontFeatureSettings: "'case' off" }}>
                      <RoleLanguage role={appState.user?.role?.description} /> 
                    </div>
                  </>
                ) : (
                  <div></div>
                )}
              </span>
            </Link>
            <CurrentUserModal isModalOpen={isModalUserOpen} setIsModalOpen={setIsModalUserOpen} />
          </div>


          
          {app.hasPermission("FINANCE_VIEW") &&
            <div className={cl.mainNavButton}>
              <Link to="/finances" onClick={handleLinkClick} className={location.pathname.startsWith('/finances') ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Car />
                </span>
                <span className={cl.textmenu} >
                  {t('Cars')}
                </span>
              </Link>
            </div>
          }


  
          {app.hasPermission("DASHBOARD_VIEW") &&

            <div className={cl.mainNavButton}>
              <Link to="/dashboard" className={location.pathname === '/dashboard' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Dashboard />
                </span>
                <span className={cl.textmenu} >
                  {t('Statistics')}
                </span>
              </Link>
            </div>
          }
 

          {app.hasPermission("CONTAINER_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/containers" onClick={handleLinkClickContainer} className={location.pathname.startsWith('/finances') ? cl.active : ''}> 
                <span className={cl.iconmenu} >
                  <ContainerIcon />
                </span>
                <span className={cl.textmenu} >
                  {t('Automobiles')}
                </span>
              </Link>
            </div>
          }
          
          {app.hasPermission("CONTAINER_PRICE_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/container-prices" className={location.pathname.startsWith('/container-prices') ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Ship />
                </span>
                <span className={cl.textmenu} >
                  {t('TransportPrice')}
                </span>
              </Link>
            </div>
          }

          {app.hasPermission("QUOTATION_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/quotation" className={location.pathname.startsWith('/quotation') ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Quotation />
                </span>
                <span className={cl.textmenu} >
                  {t('Quotation')}
                </span>
              </Link>
            </div>
          }

          {app.hasPermission("BOOKING_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/booking" className={location.pathname.startsWith('/booking') ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Booking />
                </span>
                <span className={cl.textmenu} >
                  ბუქინგი
                </span>
              </Link>
            </div>
          }

          {(app.hasPermission("TRANSPORT_PRICE_PAGE_SHOW") || app.hasPermission("SITES_PAGE_SHOW") || app.hasPermission("AGENTCRM_PAGE_SHOW")) &&
            <div className={cl.mainNavButton}>
              <Link to={app.hasPermission("TRANSPORT_PRICE_PAGE_SHOW") ? "/transport-prices" : app.hasPermission("SITES_PAGE_SHOW") ? "/transport-prices/websites" : "/transport-prices/agentcrm"} className={location.pathname.startsWith('/transport-prices') ? cl.active : ''}>
              <span className={cl.iconmenu} >
                  <Ship />
                </span>
                <span className={cl.textmenu} >
                  {t('TransportPrice')}
                </span>
              </Link>
              {location.pathname.startsWith('/transport-prices') &&
                <div className={cl.subNav}>
                  <ul>
                    {app.hasPermission("SITES_PAGE_SHOW") &&
                      <li><Link to="/transport-prices/websites" className={location.pathname.startsWith('/transport-prices/websites') ? cl.active : ''} >{t('Sites')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("AGENTCRM_PAGE_SHOW") &&
                      <li><Link to="/transport-prices/agentcrm" className={location.pathname.startsWith('/transport-prices/agentcrm') ? cl.active : ''} >{t('AgentCRM')}<Arrow /></Link></li>
                    }
                  </ul>
                </div>
              }
            </div>
          }
 
          {app.hasPermission("PARSER_PAGE") &&
            <div className={cl.mainNavButton} style={{ display: "none" }}>
              <Link to="/parser" className={location.pathname === '/parser' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} ><Car /></span>
                <span className={cl.textmenu} >პარსერი</span>
              </Link>
            </div>
          }

          {app.hasPermission("TASKS_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/tasks" className={location.pathname === '/tasks' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} ><Task /></span>
                <span className={cl.textmenu} >{t('Tasks')}</span>
              </Link>
            </div>
          }

          {app.hasPermission("SALARY_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/salaries" className={location.pathname === '/salaries' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Wallet />
                </span>
                <span className={cl.textmenu} >
                  {t('Salaries')}
                </span>
              </Link>
            </div>
          }

          {app.hasPermission("LOG_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/logs" className={location.pathname === '/logs' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} ><Logs /></span>
                <span className={cl.textmenu} >{t('Logs')}</span>
              </Link>
            </div>
          }

          {app.hasPermission("SMS_PAGE_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/sms" className={location.pathname === '/sms' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} ><Sms /></span>
                <span className={cl.textmenu} >SMS</span>
              </Link>
            </div>
          }

          {(canShowUsers || canRegisterOwnDealer) &&
            <div className={cl.mainNavButton}>
              <Link to={usersLink} className={location.pathname.startsWith('/users') ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Users />
                </span>
                <span className={cl.textmenu} >
                  
                  {t('Users')}
                </span>
              </Link>
              {location.pathname.startsWith('/users') &&
                <div className={cl.subNav}>
                  <ul>
                    {visibleUserRoles.map(role => (
                      <li key={role.id}>
                        <Link to={`/users/${role.id}`} className={location.pathname.endsWith(`/users/${role.id}`) ? cl.active : ''}>
                            <RoleLanguage role={role?.description} />

                          <Arrow />
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              }
            </div>
          }

          {(app.hasPermission("SHIPPER_PAGE_SHOW")
            || app.hasPermission("MARINE_LINE_PAGE_SHOW")
            || app.hasPermission("ROLE_PAGE_SHOW")
            || app.hasPermission("PERMISSION_PAGE_SHOW")
            || app.hasPermission("CONTAINER_PRICE_PAGE_SHOW")
            || app.hasPermission("TRANSPORT_PRICE_PAGE_SHOW")) &&
            <div className={cl.mainNavButton}>
              <Link to={linkDefaultDbPath} className={location.pathname.startsWith('/databases') ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Folder />
                </span>
                <span className={cl.textmenu} >
                  
                  {t('Databases')}
                </span>
              </Link>
              {location.pathname.startsWith('/databases') &&
                <div className={cl.subNav}>
                  <ul>
                    {app.hasPermission("AGENTS_PAGE_SHOW") &&
                      <li><Link to="/databases/agents" className={location.pathname.startsWith('/databases/agents') ? cl.active : ''} >{t('Agents')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("ROLE_PAGE_SHOW") &&
                      <li><Link to="/databases/roles" className={location.pathname.startsWith('/databases/roles') ? cl.active : ''} >{t('Roles')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("PERMISSION_PAGE_SHOW") &&
                      <li><Link to="/databases/permissions" className={location.pathname.startsWith('/databases/permissions') ? cl.active : ''} >{t('Permissions')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("SHIPPER_PAGE_SHOW") &&
                      <li><Link to="/databases/shippers" className={location.pathname.startsWith('/databases/shippers') ? cl.active : ''} >{t('Shippers')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("MARINE_LINE_PAGE_SHOW") &&
                      <li><Link to="/databases/marine_lines" className={location.pathname.startsWith('/databases/marine_lines') ? cl.active : ''} >{t('MarineLines')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("INVOICE_PAGE_SHOW") &&
                      <li><Link to="/databases/invoices" className={location.pathname.startsWith('/databases/invoices') ? cl.active : ''} >{t('Invoices')}<Arrow /></Link></li>
                    }
                    {app.hasPermission("TITLES_PAGE_SHOW") &&
                      <li><Link to="/databases/titles" className={location.pathname.startsWith('/databases/titles') ? cl.active : ''} >Titles<Arrow /></Link></li>
                    }
                    {app.hasPermission("AUCTION_FEES_PAGE_SHOW") &&
                      <li><Link to="/databases/auction-fees" className={location.pathname.startsWith('/databases/auction-fees') ? cl.active : ''} >Auction fees<Arrow /></Link></li>
                    }
                  </ul>
                </div>
              }
            </div>
          }


          
          {location.pathname.includes("containers") && (
            <div className={cl.bottomNavLinks}>
              {combinedLinkData.map((link, index) => (
                <a key={index} href={link.url} className={cl.linkItem} style={{ backgroundColor: link.color }}>
                  <span>{link.text}</span>
                  <span>{link.count}</span>
                </a>
              ))}
            </div>
          )}


 

{app.hasPermission("CALCULATOR_SHOW") &&
            <div className={cl.mainNavButton}>
              <Link to="/calculator" className={location.pathname === '/calculator' || location.pathname === '/' ? cl.active : ''}>
                <span className={cl.iconmenu} >
                  <Calculator />
                </span>
                <span className={cl.textmenu} >
                  {t('Calculator')}
                </span>
              </Link>
            </div>
          }
 

        {app.hasPermission("DOWNLOAD_APP") && 
              <Link to="https://app.aig.com.ge/" target="_blank" className={cl.appDownloadSection} rel="noopener noreferrer">
                <span className={cl.iconmenu} >
                  <Download />
                </span>
                <span className={cl.textmenu} >
                  {t('DownloadApp')}
                </span>
              </Link>
          } 


 

          <div className={cl.bottomNav}>
            <div className={cl.mainNavButton}  >
                 
                            
              <div className={cl.langlist}>
                <button
                  className={i18n.language === 'ka' ? cl.langActive : ''}
                  onClick={() => i18n.changeLanguage('ka')}
                > <Flag countryCode={'ge'} /> </button>
                <button
                  className={i18n.language === 'en' ? cl.langActive : ''}
                  onClick={() => i18n.changeLanguage('en')}
                ><Flag countryCode={'gb'} /></button>
                <button
                  className={i18n.language === 'ru' ? cl.langActive : ''}
                  onClick={() => i18n.changeLanguage('ru')}
                >
                  <Flag countryCode={'ru'} />
                </button>
              </div>

 
            </div>
            <div className={cl.mainNavButton}>
              <Link onClick={logout} >
                <span className={cl.iconmenu} >
                  <Logout />
                </span>
                <span className={cl.textmenu} >
                  {t('Logout')}
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>



      <div className={cl.overlayBG} onClick={() => {
        const nav = document.querySelector('.' + cl.navigation);
        const barBTN = document.querySelector('.' + cl.barBTN);
        const overlayBG = document.querySelector('.' + cl.overlayBG);
        nav.classList.remove(cl.active);
        barBTN.classList.remove(cl.active);
        overlayBG.classList.remove(cl.active);
      }}></div>
    </>
  );
};

export default Navigation;
